<section class="title-bar content-padding first-item">
    <div class="wrapper">
      <!-- <h2 class="left">{{smsTemplate?.id ? "Modifica" : "Nuovo"}} Modello SMS</h2> -->
      <h2 class="left">Nuovo Modello SMS</h2>
      <br class="clear">
    </div>
</section>

<section class="content-padding darker">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="_smsTemplateForm" (ngSubmit)="onSubmit()">
            <div class="col-50 grid-element">
                <label for="temp_type">Tipo{{ _smsTemplateForm.get("temp_type") | required }}</label>
                <!-- <input type="text" name="temp_type" formControlName="temp_type"> -->
                <select type="text" formControlName="temp_type">
                    <option></option>
                    <option value="Created">Created</option>
                    <option value="Started">Started</option>
                    <option value="Arrived">Arrived</option>
                </select>
                <app-error-html-handler [ctrl]="_smsTemplateForm.get('temp_type')" [messages]="formValidationMsgs.temp_type">
                </app-error-html-handler>
            </div>
            <div class="col-100 grid-element">
                <label for="description">Descrizione{{ _smsTemplateForm.get("description") | required }}</label>
                <textarea rows="5" placeholder="Scrivi una descrizione" formControlName="description"></textarea>
                <app-error-html-handler [ctrl]="_smsTemplateForm.get('description')" [messages]="formValidationMsgs.description">
                </app-error-html-handler>
            </div>
            <div class="center">
                <button class="btn hvr-shrink center" [disabled]="!_smsTemplateForm?.valid || tmpBtnDisabled" (click)="$event.preventDefault(); onSubmit()">
                  Salva<i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>
